module.exports = __webpack_public_path__ + "images/stop01.png?5ca97600637c8b966a79488652318c52";


//////////////////
// WEBPACK FOOTER
// ./static/images/stop01.png
// module id = 173
// module chunks = 0